!((document, Drupal, $, once) => {
  'use strict';
  Drupal.behaviors.collapsibleSidebar = {
    attach: function(context) {
      $(
        once(
          'collapsible-checkbox-hidden',
          '.collapsible-sidebar input[type=checkbox]',
          context
        )
      ).each(function() {
        $(this).addClass('visually-hidden');
      });

      /**
       * Toggle the sidebar.
       *
       * @param {Event} event The event.
       *
       * @returns {void}
       */
      function toggle(event) {
        const button = event.target;
        const container = button.closest('.collapsible-sidebar');
        container.classList.toggle('collapsible-sidebar--collapsed');
      }

      // get hide button and attach listener
      const collapseItemsList = context.querySelectorAll(
        '.js-sidebar-collapse-button'
      );
      // add listener to buttons to toggle class
      for (let i = 0; i < collapseItemsList.length; i++) {
        collapseItemsList[i].addEventListener('click', toggle);
      }
    }
  };
})(document, Drupal, jQuery, once); // eslint-disable-line no-undef
